import React, { Fragment, useContext } from 'react';
// import { StyleSheet, css } from 'aphrodite/no-important';
import { Loader } from '../loader';
import { useTheme } from '@emotion/react';
import { ThemeContext } from '../theme';
import { GridPager } from '../data-grid/grid-pager';

const CardsGrid = (props) => {
  const theme = useTheme();
  const context = useContext(ThemeContext);
  let dataGrid;
  if (theme && theme.dataGrid) {
    dataGrid = theme.dataGrid;
  } else {
    dataGrid = context.theme.dataGrid;
  }
  const {
    gridPagerBackground,
    gridPagerTopBorderColor,
    gridPagerTextColor,
    gridPagerFontSize,
    gridPagerDropdownTextColor,
    gridPagerIconsTextColor,
    gridPagerIconsBackground,
    gridPagerHeight
  } = dataGrid;

  const cards = [];
  props.rowData.forEach((el) => {
    // cards.push(props.cardRenderer(el));
    cards.push(
      <div key={Math.random().toString(36).slice(2)}>
        {props.cardRenderer(el)}
      </div>
    );
  });

  return (
    <>
      {props.loader
        ? <div
            style={{
              background: '#004080',
              opacity: '0.75',
              position: 'absolute',
              zIndex: '5000',
              width: `${props.gridWidth}px`,
              height: `${props.gridHeight}px`
            }}
          >
            <Loader iconType="cog" iconSize="5x" text="Loading data" />
          </div>
        : null
      }
      <div
        style={{
          ...props.style,
          // display: 'grid',
          // gap: '8px',
          // gridTemplateRows: `repeat(auto-fill, ${props.cardHeight})`,
          // gridTemplateColumns: `repeat(auto-fill, minmax(${props.cardWidth}, 1fr))`,
          // justifyItems: 'center',
          padding: '8px 0'
        }}
      >
        {cards}
      </div>
      <GridPager
          currentPage={props.currentPage}
          totalPages={props.totalPages}
          loadPage={props.onLoadPage}
          theme={{
            gridPagerBackground,
            gridPagerTopBorderColor,
            gridPagerTextColor,
            gridPagerFontSize,
            gridPagerDropdownTextColor,
            gridPagerIconsTextColor,
            gridPagerIconsBackground,
            gridPagerHeight
          }}
        />
    </>
  );
};

export { CardsGrid };
